<template>
  <div class="login-container">
    <vue-particles
      style="height: 100%; position: fixed"
      color="#8ACAFF"
      :particle-opacity="0.2"
      :particles-number="80"
      shape-type="circle"
      :particle-size="4"
      lines-color="#dedede"
      :lines-width="2"
      :line-linked="true"
      :line-opacity="0.1"
      :lines-distance="150"
      :move-speed="8"
      :hover-effect="true"
      hover-mode="grab"
      :click-effect="true"
      click-mode="push"
    />

    <div class="center-box">
      <div class="bg">
        <!-- <div class="bg-center"></div> -->
        <img src="../../image/login/bg.png" alt srcset />
      </div>
      <div class="login-box">
        <div class="login-form">
          <div class="logo">
            <img src="@/image/logo.png" alt srcset />
            <div>致善阔贤管理系统</div>
          </div>
          <div class="title_l">欢迎登录!</div>
          <div v-if="isActive === 1">
            <el-input v-model="account" placeholder="手机号" class="account" maxlength="11" clearable></el-input>
            <!-- 获取验证码 -->
            <div style="position: relative">
              <el-input v-model="verCode" placeholder="验证码" class="verCode" clearable></el-input>
              <el-button
                type="primary"
                class="getCode"
                @click="getCode"
                :disabled="disabled"
              >{{ codeBtnTitle }}</el-button>
            </div>
          </div>

          <div v-else>
            <el-input
              v-model="account"
              placeholder="请输入账号"
              class="account"
              maxlength="11"
              clearable
            ></el-input>
            <el-input
              placeholder="请输入密码"
              :type="flag ? 'text' : 'password'"
              v-model="password"
              maxlength="18"
              class="account"
              clearable
            >
              <i
                slot="suffix"
                :class="[flag ? 'el-icon-sunny' : 'el-icon-cloudy']"
                class="password_icon"
                autocomplete="auto"
                @click="flag = !flag"
              />
            </el-input>
          </div>

          <div class="rememberBtn">
            <el-checkbox v-model="passwordChecked">记住{{ isActive === 0 ? "账号密码" : "手机号" }}</el-checkbox>
          </div>

          <el-button
            type="primary"
            class="loginBtn"
            @click="loginBtn"
            v-loading.fullscreen.lock="fullscreenLoading"
            v-waves
          >登录</el-button>
        </div>
      </div>
    </div>
    <!-- 标语 -->
    <div class="life">
      <div class="h1">工作与生活均衡</div>
      <div class="h2">Work life balance</div>
    </div>
  </div>
</template>

<script>
import { loginApi } from "@/services/admin_user/index.js";
export default {
  computed: {},
  created() {
    //1记住密码  0不记住密码
    if (localStorage.getItem("passwordChecked") == 1) {
      this.passwordChecked = true;
      // 账号回显
      var loginForm = JSON.parse(localStorage.getItem("loginForm"));
      // console.log(loginForm);
      if (loginForm !== null) {
        this.account = loginForm.account;
        this.password = loginForm.password;
      }
    } else {
      this.passwordChecked = false;
    }
  },
  data() {
    return {
      flag: false,
      fullscreenLoading: false,
      account: "", //用户名或手机号
      verCode: "", //验证码
      password: "", //密码
      passwordChecked: "",
      codeBtnTitle: "验证码",
      disabled: false,
      loginStyle: ["账号登录", "手机号登录"],
      isActive: 0
    };
  },
  watch: {},
  methods: {
    activeBtn(i) {
      this.isActive = i;
    },
    /* 计时器 */
    timer() {
      let s = 60;
      this.codeBtnTitle = s + " s";
      this.disabled = true;
      let timer = setInterval(() => {
        s--;
        this.codeBtnTitle = s + " s";
        if (s === 0) {
          clearInterval(timer);
          this.codeBtnTitle = "验证码";
          this.disabled = false;
        }
      }, 1000);
    },
    /* 获取验证码 */
    getCode() {
      let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // console.log(reg_tel.test(this.account));
      if (!reg_tel.test(this.account)) {
        this.$message.error("请输入正确的手机号");
        return;
      }
      // selectProductData({ username: this.account })
      //   .then((res) => {
      //     // console.log(res);
      //     if (res.data.code === 200) {
      //       //后端协商的判断条件
      //       this.$message.success("验证码已发送，注意查收！");
      //       this.timer(); //启动倒计时
      //     } else {
      //       this.$message.error(res.data.msg);
      //     }
      //   })
      //   .catch((err) => {
      //     this.$message.error("网络异常");
      //     setTimeout(() => {
      //       this.fullscreenLoading = false;
      //     }, 1000);
      //   });
    },
    /* 登录 */
    loginBtn() {
      // var password = md5(this.password);
      var verCode = this.verCode;
      var password = this.password;
      var username = this.account;
      // 记住密码监听
      if (this.passwordChecked) {
        //将用户数据存到localStorage 长期有效 （cooking不设置时效关闭浏览器就消失了 设置才长期有效）
        localStorage.setItem("passwordChecked", 1);
        var loginForm = {
          account: this.account,
          password: this.password
        };
        localStorage.setItem("loginForm", JSON.stringify(loginForm));
      } else {
        localStorage.setItem("passwordChecked", 0);
        localStorage.removeItem("loginForm");
      }

      // let reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      // if (!reg_tel.test(this.account)) {
      //   this.$message.error("请输入正确的手机号");
      //   return;
      // }

      if (this.isActive === 0) {
        if (username === "" || password === "") {
          this.$message.error("账号或密码不能为空");
          return;
        }
      }
      if (this.isActive === 1) {
        if (username === "" || verCode === "") {
          this.$message.error("手机号或验证码不能为空");
          return;
        }
      }
      this.fullscreenLoading = true;
      loginApi({
        username,
        password
      }).then(res => {
        if (res.code === 200) {
          localStorage.setItem("token", res.data); // 保存令牌
          this.$message.success("登录成功");
          this.fullscreenLoading = false;
          this.$router.push({ name: "Welcome" });
        } else {
          setTimeout(() => {
            this.fullscreenLoading = false;
          }, 1000);
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login-container {
  // background: linear-gradient(to right, #12c2e9, #c471ed);
  background: linear-gradient(to bottom right, #1d3b45, #0a1b37);
  height: 100vh;
  width: 100%;
  position: fixed;
  overflow-x: auto;
  overflow-y: auto;
  .center-box {
    overflow: hidden;
    border-radius: 5px;
    min-height: 420px;
    width: 60%;
    height: 60%;
    max-height: 550px;
    max-width: 1000px;
    min-width: 750px;
    background: #ffffff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
    animation-name: move;
    animation-duration: 3s;
    display: flex;
  }
  @keyframes move {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }
}

/* 左边背景 */
.bg {
  // border: 1px solid red;
  width: 55%;
  height: 100%;
  // background-size: 100% 100%;
  background: linear-gradient(to bottom, #cae1f4 60%, #60c7f7);
  position: relative;
  display: flex;
  align-items: center;
  img {
    width: 100%;
  }
  .bg-center {
    width: 400px;
    height: 400px;
    background-image: url("../../image/login/bg.png");
    background-size: 100% 100%;
    background-attachment: fixed;
    background-repeat: no-repeat;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -moz-transform: translate(-50%, -50%);
  }
}
/* 右边登录 */
.login-box {
  position: relative;
  background: #f2f4f3;
  width: 45%;
  height: 100%;
  // border: 1px solid rgb(0, 0, 0);

  .login-form {
    position: absolute;
    top: 25%;
    width: 80%;
    margin: 0 auto;
    left: 0;
    right: 0;
    background: #fff;
    padding: 10px 30px;
    border-radius: 20px;

    .logo {
      position: absolute;
      top: -25%;
      left: 0;
      right: 0;
      margin: 0 auto;
      display: flex;
      align-items: center;
      font-size: 16px;
      height: 60px;
      text-align: center;
      justify-content: center;
      img {
        width: 50px;
        display: block;
        margin-right: 5px;
      }
      div {
        letter-spacing: 2px;
        color: #4b5050;
        font-weight: 550;
      }
    }
    .title_l {
      margin: 20px auto 30px;
      color: #262626 !important;
      font-weight: 800;
      font-size: 1.2em;
      /* text-align: center; */
      /* width: 100%; */
    }
    .password_icon {
      position: absolute;
      font-size: 16px;
      right: 30px;
      top: 12.5px;
    }
    .password_icon:hover {
      cursor: pointer;
      color: #111111ca;
    }
    /* 登录方式切换 */
    .loginStyle {
      display: flex;
      width: 100%;
      margin: 10px auto;
      color: #6b6b6b;
    }
    .active {
      color: #409eff !important;
      font-weight: 550;
    }

    .loginStyle > div {
      margin: 20px 15px 20px 0px;
    }
    .loginStyle > div:hover {
      cursor: pointer;
    }
    .account {
      margin: 10px auto;
      width: 100%;
      display: block;
      position: relative;
    }
    .verCode {
      display: block;
      margin: 10px auto;
      width: 100%;
    }
    .getCode {
      position: absolute;
      top: 0px;
      right: 10%;
      width: 85px;
    }
    .rememberBtn {
      margin: 0 auto;
      width: 100%;
    }
    .loginBtn {
      margin: 20px auto;
      width: 100%;
      display: block;
    }
  }
}

/* 标语 */
.life {
  position: fixed;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 50px;
  text-align: center;
  font-weight: 200;
  .h1 {
    color: #fff;
    font-size: 26px;
  }
  .h2 {
    color: #939393;
    font-size: 16px;
  }
}
</style>
